import "./style.css";
export const SideSection = ({ title, value, className }) => {
  return (
    <div className={`col-row ${className}`}>
      <span className="col-label">{title}</span>
      <span className="col-val">{value}</span>
    </div>
  );
};